import { createSagaAction } from '../../shared/sagas'
import { createReducer } from '../../shared/reducers'

// Constants
export const constants = {
  GET_CONTRACT_PAYMENT_SCHEDULE_TEMPLATE: createSagaAction(
    'GET_CONTRACT_PAYMENT_SCHEDULE_TEMPLATE'
  ),
  GET_CONTRACT_PAYMENT_SCHEDULE: createSagaAction('GET_CONTRACT_PAYMENT_SCHEDULE')
}

// Action Creators
export const actions = {
  getContractPaymentScheduleTemplate: ({ templateId }) => ({
    type: constants.GET_CONTRACT_PAYMENT_SCHEDULE_TEMPLATE.ACTION,
    templateId
  }),

  getContractPaymentSchedule: ({ contractId }) => ({
    type: constants.GET_CONTRACT_PAYMENT_SCHEDULE.ACTION,
    contractId
  })
}

// Reducer
const initialState = []

export default createReducer(initialState, (state, { type, payload }) => {
  switch (type) {
    default:
      return state
    case constants.GET_CONTRACT_PAYMENT_SCHEDULE_TEMPLATE.SUCCESS:
      return { ...state, contractPaymentScheduleTemplate: payload }
    case constants.GET_CONTRACT_PAYMENT_SCHEDULE.SUCCESS:
      return { ...state, contractPaymentSchedules: payload }
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/contractActions.js